module.exports = __webpack_public_path__ + "img/panama.1e5cec28.svg";